import { render, staticRenderFns } from "./manualCustomer.vue?vue&type=template&id=811c6770"
import script from "./manualCustomer.vue?vue&type=script&lang=js"
export * from "./manualCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports